import { CommentInterface, DossierCommentInterface } from '@/services/QA/comment/interfaces';

export interface TotalStatisticInterface {
  chats: number,
  tickets: number,
  escalations: number
  feedbacks: number,
}

export interface TotalDailyStatisticInterface {
  date: string,
  chats: number,
  tickets: number,
  escalations: number
  feedbacks: number,
}

export interface ScoreDailyStatisticInterface {
  date: string,
  average: number,
  label: string,
  total_chats: number
  total_score: number
}

export interface ChatScoreStatisticInterface {
  label: string,
  total_chats: number,
  average: number,
}

export interface TicketScoreStatisticInterface {
  label: string,
  total_tickets: number,
  average: number,
}

export interface ScoreStatisticInterface {
  chatScores: ChatScoreStatisticInterface[],
  ticketScores: TicketScoreStatisticInterface[],
}

export interface DailyChatScoreStatisticInterface {
  date: string,
  label: string,
  totalChats: number,
  average: number,
}

export interface DailyTicketScoreStatisticInterface {
  date: string,
  label: string,
  totalTickets: number,
  average: number,
}

export interface DailyScoreStatisticInterface {
  chatScores: DailyChatScoreStatisticInterface[],
  ticketScores: DailyTicketScoreStatisticInterface[],
}

export interface ChatTagStatisticInterface {
  tagId: number;
  count: number;
}

export interface TicketTagStatisticInterface {
  tagId: number;
  count: number;
}

export interface TagStatisticInterface {
  chatTags: ChatTagStatisticInterface[];
  ticketTags: TicketTagStatisticInterface[];
}

export interface StatisticsResponseInterface {
  totalStatistic: TotalStatisticInterface,
  scoreStatistic: ScoreStatisticInterface,
  tagStatistic: TagStatisticInterface,
  dailyMainStatistic: TotalDailyStatisticInterface[]
  dailyScoreStatistic: DailyScoreStatisticInterface
}

export interface LineChartDatasetInterface {
  label: string,
  data: number[],
  borderColor: string,
  fill: boolean,
  tension: number
  additionalData?: unknown[]
}

export interface LineChartInterface {
  labels: string[],
  datasets: LineChartDatasetInterface[];
}

export const lineChartColors = [
  '#009aff',
  '#fd440e',
  '#55f172',
  '#a700ff',
];

export interface SupportAgentStatisticResponse {
  scoreStatistic: ScoreStatisticInterface,
  totalStatistic: TotalStatisticInterface
}

export interface AgentStatisticResponseInterface {
  qaAgentStatistic?: TotalStatisticInterface,
  supportAgentStatistic?: SupportAgentStatisticResponse,
}


export interface StatisticsRepositoryInterface {
  getMainStatistics(fromDate: string, toDate: string): Promise<StatisticsResponseInterface>;

  getAgentStatistic(id: string, fromDate?: string, toDate?: string): Promise<StatisticsResponseInterface>;

  getAgentComments(userId: string): Promise<DossierCommentInterface[]>;

  createComment(userId: string, comment: Partial<CommentInterface>): Promise<DossierCommentInterface>;
}
